import {Stack} from '@mui/material';
import {FC} from 'react';
import {useRequestMapStore} from '../../store/useRequestMapStore';
import {ContractsList} from '../ContractsList';
import {RequestMap} from '../RequestMap';
import {isNil} from 'lodash';

interface Props {
  serviceType: string;
}

export const MapValue: FC<Props> = ({serviceType}) => {
  const selectedContractId = useRequestMapStore((s) => s.selectedContractId);

  return (
    <Stack gap={2} height="100%">
      {isNil(selectedContractId) ? <ContractsList /> : <RequestMap serviceType={serviceType} />}
    </Stack>
  );
};
